function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6055 0.75C13.4688 0.75 13.3047 0.804688 13.1406 0.859375L1.76562 6.10938C0.453125 6.71094 0.890625 8.65234 2.28516 8.65234H7.09766V13.4648C7.09766 14.2852 7.78125 14.75 8.4375 14.75C8.90234 14.75 9.39453 14.5312 9.64062 13.9844L14.8906 2.60938C15.2734 1.70703 14.5078 0.75 13.6055 0.75ZM14.0977 2.25391L8.84766 13.6016C8.76562 13.793 8.62891 13.9023 8.4375 13.9023C8.27344 13.9023 7.97266 13.793 7.97266 13.4648V7.77734H2.28516C1.98438 7.77734 1.90234 7.53125 1.875 7.42188C1.84766 7.28516 1.84766 7.03906 2.14844 6.90234L13.4688 1.67969C13.5234 1.65234 13.5781 1.625 13.6055 1.625C13.7695 1.625 13.9336 1.73438 14.043 1.89844C14.0977 1.98047 14.1523 2.11719 14.0977 2.25391Z",
  fill: "#01000E"
});

function SvgCurrentLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.b09a26e6.svg";
export { ForwardRef as ReactComponent };